<template>
<b-modal ref="shareModal" size="lg" hide-footer>
  <template v-slot:modal-title>
    <h3>Share</h3>
  </template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="exampleInputEmail1">Your Email Address</label>
          <input type="email" v-model="respondTo" class="form-control" aria-describedby="emailHelp" placeholder="Enter email">
        </div>
        <div class="form-group">
          <label for="exampleInputEmail1">Share Email Address</label>
          <input type="email" v-model="sendTo" class="form-control" aria-describedby="emailHelp" placeholder="Enter email">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 second">
        <button v-on:click="hideShareModal" class="btn btn-secondary">Cancel</button>
      </div>
      <div class="col-md-6">
        <button v-on:click="share" class="btn btn-primary">Submit</button>
      </div>
    </div>
  </div>
</b-modal>
</template>

<script>
export default {
  data () {
    return {
      respondTo: null,
      sendTo: null
    }
  },
  props: {
    shareType: String,
    typeData: Object
  },
  methods: {
    hideShareModal () {
      this.$refs.shareModal.hide()
    },
    async share () {
      if (this.validateEmail(this.respondTo)) return
      if (this.validateEmail(this.sendTo)) return
      // if (!this.message) return
      var client = this.$store.getters.getEmailApigClientFactory
      var params = {}
      var pathTemplate = '/share'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        share_type: this.shareType,
        respond_to: this.respondTo,
        send_to: this.sendTo,
        type_data: this.typeData
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.hideShareModal()
      } catch (error) {
        console.log(error)
      }
    },
    validateEmail (email) {
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(email)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
@media (max-width: 992px) {
  .second {
    -ms-flex-order: 2;
    order: 2;
  }
}

.btn-secondary {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/general/modals/TheShareModal.vue